var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MobileGoogleAdsPopup',{staticStyle:{"margin":"0 auto"},attrs:{"path":"/22163595876/RTBGo_Web_Mobile_320x250","size":[320, 250],"id":"RTBGo_Web_Mobile"}})}
var staticRenderFns = []

export { render, staticRenderFns }